
import { defineComponent, reactive, ref, watch, PropType, onMounted, onUpdated } from 'vue';
import { Bar } from './charts';
import { Line } from './charts';
import { useI18n } from 'vue-i18n';
import numeral from 'numeral';

export interface RankingDataItem {
  title: string;
  total: number | string;
}

export default defineComponent({
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Function as PropType<(type: any) => void>,
      default: () => {
        return undefined;
      },
    },
    getTypes: {
      type: Function,
      default: () => {
        return undefined;
      },
    },
    selectDate: {
      type: Function as PropType<(type: any) => void>,
      default: () => {
        return undefined;
      },
    },
    handleRangePickerChange: {
      type: Function,
      default: () => {
        return undefined;
      },
    },
    rangePickerValue: {
      type: Array as PropType<RankingDataItem[]>,
      required: true,
    },
    salesData: {
      type: Object,
      required: true,
    },
    rankData: {
      type: Object,
      required: true,
    },
  },
  setup(props: any) {
    const { t, locale } = useI18n();
    const activeKey = ref('cz_price');
    const rankActiveKey = ref('');
    const state = reactive({
      rankingListData: [] as RankingDataItem[],
      newRankData: {
        list_cz: [] as any[],
      },
      page_index: 1,
      page_size: 7,
    });
    const formatYuan = (val: string | number) => `¥ ${numeral(val).format('0,0')}`;
    const readData = () => {
      state.page_index = 1;
      state.page_size = 7;
      loadData();
    };
    const loadData = () => {
      state.newRankData.list_cz = [];
      props.rankData.list_cz.map((obj: any) => {
        let new_obj = Object.assign({}, obj);
        let start_node = (state.page_index - 1) * state.page_size;
        let end_node = state.page_index * state.page_size;
        new_obj.data_count = obj.rank.length;
        new_obj.page_count = Math.ceil(obj.rank.length / state.page_size);
        new_obj.rank = obj.rank.filter((item: any, index: any) => {
          return start_node <= index && index < end_node;
        });
        state.newRankData.list_cz.push(new_obj);
      });
    };
    const changePage = (type: any, page_count: any) => {
      if (state.page_index > 1 && type == -1) {
        state.page_index -= 1;
      } else if (state.page_index + 1 <= page_count && type == 1) {
        state.page_index += 1;
      }
      loadData();
    };
    const generatorRankingData = () => {
      state.rankingListData = [];
      for (let i = 0; i < 7; i += 1) {
        state.rankingListData.push({
          title: t('dashboard.analysis.test', { no: i }),
          total: 323234,
        });
      }
    };

    onMounted(() => {
      generatorRankingData();
      loadData();
      watch(
        () => locale.value,
        () => {
          generatorRankingData();
          loadData();
        },
      );
    });

    onUpdated(() => {
      readData();
    });

    return {
      t,
      numeral,
      state,
      activeKey,
      rankActiveKey,
      formatYuan,
      changePage,
    };
  },
  components: {
    Bar,
    Line,
  },
});
